export enum DischargeAssessmentSections {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  DISCHARGE_SUMMARY = 'discharge-summary',
  PATIENT_OVERVIEW = 'patient-overview',
  MEDICATIONS = 'medications',
  MEDICAL_BACKGROUND = 'medical-background',
  FINAL_STEPS = 'final-steps'
}

export const DischargeAssessmentAnchors = [
  {
    key: DischargeAssessmentSections.ASSESSMENT_OVERVIEW,
    href: '#assessment-overview',
    title: 'Assessment Overview'
  },
  {
    key: DischargeAssessmentSections.DISCHARGE_SUMMARY,
    href: '#discharge-summary',
    title: 'Discharge Summary'
  },
  {
    key: DischargeAssessmentSections.PATIENT_OVERVIEW,
    href: '#patient-overview',
    title: 'Patient Overview'
  },
  {
    key: DischargeAssessmentSections.MEDICATIONS,
    href: '#medications',
    title: 'Medications'
  },
  {
    key: DischargeAssessmentSections.MEDICAL_BACKGROUND,
    href: '#medical-background',
    title: 'Medical Background'
  },
  {
    key: DischargeAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]

export const DischargeDemoAssessmentAnchors = [
  {
    key: DischargeAssessmentSections.DISCHARGE_SUMMARY,
    href: '#discharge-summary',
    title: 'Discharge Summary'
  },
  {
    key: DischargeAssessmentSections.PATIENT_OVERVIEW,
    href: '#patient-overview',
    title: 'Patient Overview'
  },
  {
    key: DischargeAssessmentSections.MEDICATIONS,
    href: '#medications',
    title: 'Medications'
  },
  {
    key: DischargeAssessmentSections.MEDICAL_BACKGROUND,
    href: '#medical-background',
    title: 'Medical Background'
  },
  {
    key: DischargeAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]

// Add sections here as they are migrated from controlled to uncontrolled
export const UNCONTROLLED_FORM_SECTION: Set<DischargeAssessmentSections> = new Set([
  DischargeAssessmentSections.ASSESSMENT_OVERVIEW,
  DischargeAssessmentSections.DISCHARGE_SUMMARY,
  DischargeAssessmentSections.PATIENT_OVERVIEW,
  DischargeAssessmentSections.MEDICATIONS,
  DischargeAssessmentSections.MEDICAL_BACKGROUND,
  DischargeAssessmentSections.FINAL_STEPS
])
